export default __webpack_public_path__ + "static/media/Yellow0001.aa4d6439.png";